import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EquipmentStatus, ModalDialogType, OrderConditions, OrderStatus, OrderType, ServiceType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { DateUtils } from 'src/app/@core/utils/date-utils';
import { CancellationReason } from 'src/app/models/cancellation-reason';
import { ColumnTable } from 'src/app/models/column-table';
import { Discount } from 'src/app/models/discount';
import { Invoice } from 'src/app/models/invoice';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { Receipt } from 'src/app/models/receipt';
import { OrderRequest } from 'src/app/models/requests/order-request';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { TaxExemption } from 'src/app/models/tax-exemption';
import { AuthService } from 'src/app/services/auth.service';
import { CancellationReasonService } from 'src/app/services/cancellation-reason.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EquipmentRegistrationService } from 'src/app/services/equipment-registration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';
import { ParamsService } from 'src/app/services/params.service';
import { ProductsService } from 'src/app/services/products.service';
import { ReceiptsService } from 'src/app/services/receipts.service';
import { TaxesService } from 'src/app/services/taxes.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-return-order',
  templateUrl: './create-return-order.component.html',
  styleUrls: ['./create-return-order.component.sass']
})
export class CreateReturnOrderComponent implements OnInit {

  isLoaded: boolean = false;
  invoiceCode: string = "";
  receiptCode: string = "";
  invoice: Invoice = new Invoice();
  order: Order = new Order();
  customerInformation: string = "";
  branchInformation: string = "";
  productsCart: Paging<Array<ProductCart>> = new Paging([]);
  cancellationReasons: Array<CancellationReason> = [];
  cancellationReasonSelected: CancellationReason = new CancellationReason();
  observationResult: string = "";
  receipt: Receipt = new Receipt();
  constructor(private posObservationsService: PosOrderObservationsService, private invoiceService: InvoiceService, private toastrService: ToastrService, private orderService: OrderService, private cancellationReasonService: CancellationReasonService, private taxesService: TaxesService, private configService: ConfigurationService, private authService: AuthService, private router: Router, private confirmService: PosConfirmationService, private equipmentRegistrationService: EquipmentRegistrationService, private productService: ProductsService, private receiptService: ReceiptsService, private readonly route: ActivatedRoute, private readonly exceptionSolutionService: ExceptionSolutionService, private readonly paramService: ParamsService) { }

  async ngOnInit(): Promise<void> {
    this.cancellationReasons = (await this.cancellationReasonService.readCancellationReasons().toPromise()).response.content;

    if (this.route.snapshot.queryParams.invoiceCode) {
      this.invoiceCode = this.route.snapshot.queryParams.invoiceCode;
      await this.searchInvoice();
    }
    else if (this.route.snapshot.queryParams.receiptCode) {
      this.receiptCode = this.route.snapshot.queryParams.receiptCode;
      await this.searchReceipt();
    }

  }

  async create() {

    let confirmResult = await this.confirmService.showAsync("Creación de Orden",
      "¿Esta seguro de querer crear esta orden para Devolución?", ModalDialogType.SUCCESS);

    if (!confirmResult || !await this.createValidations()) {
      return;
    }
    let orderRequest: OrderRequest = new OrderRequest();
    let customerModel = new CustomerTableModel();
    customerModel.code = this.order.customerCode;
    customerModel.fullName = `${this.order.customerName} ${this.order.customerLastName}`;
    customerModel.fiscalId = this.order.customerFiscalId;
    let sellerModel = new CustomerTableModel();
    sellerModel.code = this.authService.readProfileInStorage().username;
    sellerModel.fullName = this.authService.readProfileInStorage().fullname;
    orderRequest = orderRequest.buildReturnOrderRequest(this.productsCart.content.filter(f => f.inputMarkForReturn),
      (await this.taxesService.readTaxes().toPromise()).response.content,
      customerModel, sellerModel,
      this.configService.readSelectedBranchAndSalesOrg().branch.code, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code,
      new TaxExemption(), this.order.discounts?.length > 0 ? this.order.discounts[0] : new Discount(), [], "",
      this.observationResult, OrderType.RETURN, OrderStatus.FINAL,
      this.order.condition == "credito" ? OrderConditions.FINAL_CUSTOMER_CREDIT : undefined,
      undefined, undefined, undefined, undefined, undefined, this.cancellationReasonSelected.code, undefined, this.order);

    orderRequest.invoiceNumber = this.invoiceCode;
    orderRequest.invoiceCode = this.invoice.code;
    orderRequest.receiptCode = this.receipt.code;
    let result = (await this.orderService.createOrder(orderRequest, false).toPromise()).response;

    if (result && result.code) {
      Swal.fire({
        title: `Devolución`,
        html: `Orden de Devolución ${result.code} se ha creado con éxito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
      this.router.navigate(["returnInvoices", result.code]);
    }
  }
  async createValidations() {

    if (this.productsCart.content.every(f => !f.inputMarkForReturn)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se han escogido productos para devolver.`);
      return false;
    }
    if (this.productsCart.content.some(f => f.inputMarkForReturn && f.inputReturnedAmount == 0)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se han escogido productos para devolver.`);
      return false;
    }
    if (!this.cancellationReasonSelected || !this.cancellationReasonSelected.code) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `Tiene que escoger una Motivo de Devolución`);
      return false;
    }
    if (! await this.extraWarrantyValidations()) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se puede devolver este producto sin devolver la extragarantia primero.`);
      return false;
    }
    if (await this.hasGiftCards()) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se puede devolver esta orden porque contiene giftcards/tarjetas de regalo, por favor utilizar la opción adecuada para completar esta operación`);
      return false;
    }
    return true;
  }

  async hasGiftCards() {
    const giftCardProduct = (await this.paramService.readParam("giftcard-product-code").toPromise()).response.value ?? "";
    return this.productsCart.content.some(s => s.productCode == giftCardProduct);
  }
  async extraWarrantyValidations() {
    let result = true;

    if (this.order.orderEntryList.some(f => f.services.length > 0)) {
      for (let f of this.order.orderEntryList.filter(f => f.services.length > 0)) {
        let firstService = f.services[0];
        let entry = this.order.orderEntryList.find(e => e.code == firstService && e.returnedQuantity < e.deliveredQuantity);

        if (entry) {
          let product = (await this.productService.readProduct({ branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code, productCode: entry.productCode }).toPromise()).response;
          if (product.serviceType == ServiceType.EXTRA_WARRANTY && this.productsCart.content.some(p => p.code.toString() == entry?.code && !p.inputMarkForReturn) && this.productsCart.content.some(p => p.code.toString() == f.code && p.inputMarkForReturn)) {
            result = false;
          };
        }
      }

    }
    else {
      const equipmentRegistrations = await this.equipmentRegistrationService.readEquipmentRegistration({ page: 0, pageSize: 200, value: { orderCode: this.order.code } }).toPromise();
      const services = equipmentRegistrations.response.content.filter(f => f.equipmentRegistrationRequestModel.serviceCode);
      this.productsCart.content.filter(f => f.inputMarkForReturn).forEach(x => {
        let service = services.find(f => f.equipmentRegistrationRequestModel.serial == x.serial);
        if (service?.equipmentRegistrationRequestModel.status == EquipmentStatus.VIGENTE) {
          result = false;
        }
      })
    }

    return result;
  }

  async observations() {
    await this.posObservationsService.show(this.observationResult, (result: string) => {
      this.observationResult = result;
    });
  }

  async searchInvoice() {
    if (this.invoiceCode) {
      this.clearReceiptInfo();
      this.invoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 10, value: { fullNumber: this.invoiceCode, salesOrg: this.configService.readSelectedBranchAndSalesOrg().salesOrg.code } }).toPromise()).response.content[0] || new Invoice();
      if (!this.validateOnSelecting()) {
        this.clear();
        return;
      }
      if (this.invoice.code) {
        this.isLoaded = true;
        this.customerInformation = `[${this.invoice.customerCode}] - ${this.invoice.customerName} ${this.invoice.customerLastName}`
        this.branchInformation = `[${this.invoice.branchCode}] - ${this.invoice.branchName}`;
        this.order = (await this.orderService.readOrder(this.invoice.orderCode).toPromise()).response;
        this.loadProductsCart(this.invoice.deliveryInvoiceLines.map(s => s.orderEntryCode));
      }
      else {
        this.isLoaded = false;
        this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No existe código de factura`);
      }

    }
  }

  clearReceiptInfo() {
    this.receiptCode = "";
    this.receipt = new Receipt();
  }

  clearInvoiceInfo() {
    this.invoiceCode = "";
    this.invoice = new Invoice();
  }

  validateOnSelecting() {
    const permittedOrderTypes = new Set([OrderType.REGULAR]);
    if (this.invoice?.orderType && !permittedOrderTypes.has(this.invoice.orderType)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, this.getErrorMessageOnSelecting(this.invoice.orderType));
      return false;
    }
    if (this.receipt?.orderType && !permittedOrderTypes.has(this.receipt.orderType)) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, this.getErrorMessageOnSelecting(this.receipt.orderType));
      return false;
    }
    return true;
  }
  getErrorMessageOnSelecting(orderType: OrderType): string {
    switch (orderType) {
      case OrderType.REPAIRSHOP:
        return "No se puede devolver facturas de taller";
      default:
        return `Solo se pueden hacer devoluciones de facturas`;
    }
  }

  async searchReceipt() {
    if (this.receiptCode) {
      this.clearInvoiceInfo();
      this.receipt = (await this.receiptService.readReceipts({ page: 0, pageSize: 1, value: { code: this.receiptCode } }).toPromise()).response.content[0];
      if (!this.validateOnSelecting()) {
        this.clear();
        return;
      }
      if (this.receipt.code && this.receipt.salesOrg == this.configService.readSelectedBranchAndSalesOrg().salesOrg.code) {

        if (this.receipt.debitNote) {
          this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se puede devolver una nota de cargo.`);
          this.clear();
          return;
        }
        this.order = (await this.orderService.readOrder(this.receipt.orderCode).toPromise()).response;
        if (!await this.validateIsPlate() && DateUtils.getDateFromStringForReports(this.receipt.timeStamp).getTime() < new Date().getTime()) {
          this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se pueden devolver recibos de otro día.`);
          this.clear();
          return;
        }
        if (this.receipt.isDownPaymentReceipt) {
          this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No se puede devolver el recibo ya que pertenece a una prima de un contrato.`);
          this.clear();
          return;
        }
        this.isLoaded = true;
        this.customerInformation = `[${this.receipt.customerCode}] - ${this.receipt.customerName} ${this.receipt.customerLastName}`
        this.branchInformation = `[${this.receipt.branchCode}] - ${this.receipt.branchName}`;


        this.loadProductsCart(this.receipt.details.map(s => s.orderEntryCode));
      }
      else {
        this.isLoaded = false;
        this.exceptionSolutionService.showAlertWithSolution(`Devolución ${this.invoice.fullNumber || this.receipt.code}`, `No existe código de recibo para la sociedad ${this.configService.readSelectedBranchAndSalesOrg().salesOrg.code}`);
      }

    }
  }
  async validateIsPlate() {
    const plateService1 = (await this.paramService.readParam('plate-service-product-1').toPromise()).response?.value ?? "";
    const plateService2 = (await this.paramService.readParam('plate-service-product-2').toPromise()).response?.value ?? "";

    return this.order.orderEntryList.some(s => s.productCode == plateService1 || s.productCode == plateService2);
  }

  clear() {
    this.isLoaded = false;
    this.invoiceCode = "";
    this.order = new Order();
    this.invoice = new Invoice();
    this.productsCart = new Paging([]);
    this.customerInformation = "";
    this.branchInformation = "";
    this.receiptCode = "";
    this.receipt = new Receipt();
  }

  getProductCartHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("inputMarkForReturn", "#", {
        type: 'switch', editable: true, selectedAllSwitch: true,
        disableSwitchFn: (product: ProductCart) => {
          return product.returnedAmount == product.amount;
        },
        selectAllSwitchFn: (productsCart: Paging<ProductCart[]>, result: boolean) => {
          if (result) {
            productsCart.content.forEach(f => f.inputReturnedAmount = f.amount);
          }
          else {
            productsCart.content.forEach(f => f.inputReturnedAmount = 0);
          }
          this.productsCart = new Paging(productsCart.content);
        }
      }),
      new ColumnTable("amount", "#", { type: "number", iconClass: "fa fa-shopping-cart", isIcon: true }),
      new ColumnTable("returnedAmount", "Devuelto", { type: 'number' }),
      new ColumnTable("productCode", "Código", { isSmall: true }),
      new ColumnTable("description", "Descripción", { isSmall: true }),
      new ColumnTable("serial", "Serie", { type: "badge" }),
      new ColumnTable("price", "Sub-Total", { type: "currency" }),
      new ColumnTable("discountTotal", "Descuento", { type: "currency" }),
      new ColumnTable("taxTotal", "Impuesto", { type: "currency" }),
      new ColumnTable("total", "Total", { type: "currency" }),
      new ColumnTable("inputReturnedAmount", "Cant. Devolución", {
        type: "number",
        iconClass: 'fa fa-cart-arrow-down', isIcon: true, editable: true,
        disableSwitchFn: (product: ProductCart) => {
          return product.returnedAmount == product.amount;
        }
      }),
      new ColumnTable("code", "#", { type: "hidden" }),
      new ColumnTable("discount", "#", { type: "hidden" }),
      new ColumnTable('discount2', '', { type: 'hidden' }),
      new ColumnTable("associatedOrderEntry", "#", { type: "hidden" }),
      new ColumnTable("isDelivery", "#", { type: "hidden" }),
    ]
  }

  loadProductsCart(lines: Array<string>) {
    this.productsCart = new Paging(this.order.orderEntryList.filter(f => lines.includes(f.code)).map(o => {
      let result = new ProductCart();
      result.code = parseInt(o.code);
      result.productCode = o.productCode;
      result.description = o.productName;
      result.amount = o.deliveredQuantity;
      result.returnedAmount = o.returnedQuantity;
      result.serial = o.serialNumber;
      result.price = o.price.amount;
      result.discount = (o.discounts?.length > 0) ? o.discounts[0] : result.discount;
      result.discount2 = (o.discounts?.length > 1) ? o.discounts[1] : result.discount2;
      result.discountTotal = o.totals.discountTotal;
      result.taxTotal = o.totals.taxTotal;
      result.total = o.totals.netTotal;
      result.associatedOrderEntry = "";
      result.isDelivery = o.isForDelivery;
      result.features = o.features;

      return result;
    }))
  }

  async saveProductCart(table: Array<ProductCart>): Promise<void> {

    this.productsCart.content = table.filter(f => f.code != undefined);
    if (table.some(f => f.inputReturnedAmount > f.amount)) {
      table.forEach(f => {
        f.inputReturnedAmount = f.inputReturnedAmount > f.amount ? f.amount : f.inputReturnedAmount;
      })
      this.productsCart = new Paging(table);
    }
  }
}
